import { isNil } from 'lodash'

import { createMemberGroupApi } from '@eastcoal/api/auth/group/createMemberGroup'
import { updateMemberGroupApi } from '@eastcoal/api/auth/group/updateMemberGroup'

import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'
import { CrudModalForm } from '@eastcoal/formily/components/CrudModalForm'
import { CancelButton } from '@eastcoal/formily/components/CrudModalForm/shared/CancelButton'
import { useCreationForm } from '@eastcoal/formily/hooks/useCreationForm'

import { LimitMemberTransfer } from '../../../../../../../components/LimitMemberTransfer'
import { useCustomMemberGroupStore } from '../Store/hooks'

import { MemberGroupFormData, MemberGroupModalFormProps } from './interface'
import { CustomGroupFormSubmitButton } from './SubmitButton'
import { formatterFormData } from './utils'

const schema: MemberGroupModalFormProps['schema'] = [
  {
    name: 'members',
    type: 'array',
    'x-component': LimitMemberTransfer
  }
]

const createApi: MemberGroupModalFormProps['createApi'] = values =>
  createMemberGroupApi(formatterFormData(values))

const updateApi: MemberGroupModalFormProps['updateApi'] = values =>
  updateMemberGroupApi(formatterFormData(values))

export const MemberGroupModalForm = () => {
  const {
    currentGroup,
    formVisible,
    toggleFormVisible,
    value = [],
    onChange
  } = useCustomMemberGroupStore(state =>
    pick(state, [
      'currentGroup',
      'formVisible',
      'toggleFormVisible',
      'value',
      'onChange'
    ])
  )

  const form = useCreationForm({
    values: {
      groupName: '自定义分组',
      temporary: true,
      ...(currentGroup || {})
    } as MemberGroupFormData
  })

  const handleSuccessSubmit: MemberGroupModalFormProps['onSuccess'] =
    values => {
      onChange?.(value.filter(group => !group.temporary).concat(values))
      form.reset('*')
    }

  const formMode = isNil(form.values?.id) ? FormMode.CREATE : FormMode.UPDATE

  return (
    <CrudModalForm
      createApi={createApi}
      form={form}
      mode={formMode}
      name='customMemberGroupForm'
      open={formVisible}
      schema={schema}
      size={1000}
      type='modal'
      updateApi={updateApi}
      actions={[
        <CancelButton key='customMemberGroupCancelButton' />,
        <CustomGroupFormSubmitButton key='customMemberGroupSubmitButton' />
      ]}
      onOpenChange={toggleFormVisible}
      onSuccess={handleSuccessSubmit}
    />
  )
}
